import registerVideo from "../../../assets/auth_video/register.mp4"

export const REGISTER_VIDEO = registerVideo;